import { Sparkles, GraduationCap, Smartphone, Brain, BookMarked, TrendingUp } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Sparkles, label: "Self-Paced Learning"  },
  { icon: GraduationCap, label: "Classroom Friendly" },
  { icon: Smartphone, label: "Mobile Responsive"   },
  { icon: Brain, label: "AI-Powered"               },
  { icon: BookMarked, label: "Interactive Lessons" },
  { icon: TrendingUp, label: "Progress Tracking"   },
];

/**
 * PlatformPreviewSection — uses the branded 8-panel SaaS mockup image
 * (Dashboard · Journey · DISC Birds · LemonBot Chat · Certificate ·
 * Plan Builder · Pitch · Progress) as the centerpiece. HTML text
 * carries the headline + supporting copy + 6 capability pills.
 */
export default function PlatformPreviewSection() {
  return (
    <section
      id="platform"
      className="relative bg-[#FDFBF7] py-20 sm:py-28 overflow-hidden"
      data-testid="platform-preview-section"
    >
      <div aria-hidden="true" className="absolute top-0 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full bg-[#00E65C]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12">
          <p className="text-xs font-black tracking-[0.22em] uppercase text-gray-500 mb-3">
            The Platform
          </p>
          <h2 className="text-[32px] md:text-5xl font-black tracking-tighter leading-[1.05] text-black">
            A Real Platform.{" "}
            <span className="lsbp-green-chip">Real Student Outcomes.</span>
          </h2>
          <p className="mt-4 text-base md:text-xl text-gray-700">
            Students don't just read about business. They build, track,
            practice, pitch, and share their progress inside a guided
            learning platform.
          </p>
        </div>

        {/* Premium framed mockup */}
        <div
          className="relative mx-auto max-w-5xl rounded-[2rem] bg-black p-3 sm:p-4 shadow-[0_30px_80px_rgba(0,0,0,0.25)]"
          data-testid="platform-mockup-frame"
        >
          <img
            src="/assets/landing/platform-preview.png"
            alt="Modern student learning dashboard showing entrepreneurship lessons, LemonBot chat, journey map, DISC Birds profile, progress tracking, certificates, business plan builder, and pitch competition tools."
            className="w-full h-auto rounded-[1.5rem] block"
            loading="lazy"
            data-testid="platform-mockup-image"
          />
        </div>

        {/* Capability pills */}
        <ul
          className="mt-10 grid grid-cols-2 lg:grid-cols-6 gap-3 max-w-5xl mx-auto"
          data-testid="platform-highlights"
        >
          {HIGHLIGHTS.map((h) => (
            <li
              key={h.label}
              className="bg-white ring-1 ring-black/10 rounded-2xl p-3 text-center"
            >
              <h.icon className="w-5 h-5 mx-auto mb-1.5 text-[#00E65C]" />
              <p className="text-[11px] sm:text-xs font-extrabold text-black leading-tight">
                {h.label}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
